export default {
    isValidDate(model) {
        return !(model.dates.length === 0);
    },

    isValidClockIn(model) {
        return !(model.clock_in == null || model.clock_in === "");
    },

    isValidClockOut(model) {
        return !(model.clock_out == null || model.clock_out === "");
    },

    isInvalidClockInOut(model) {
        let valid = null;
        let currentDateTime = Vue.moment();

        for (let i=0; i < model.dates.length; i++){
            let date = model.dates[i];
            let start = Vue.moment(date+" "+model.clock_in, "YYYY-MM-DD HH:mm:ss");
            let end = Vue.moment(date+" "+model.clock_out, "YYYY-MM-DD HH:mm:ss");
            if (model.clock_in === model.clock_out){
                valid = 'Clock in time cannot be the same as clock out time. Please adjust and try again.';
                break;
            } else if (start > currentDateTime || end > currentDateTime){
                valid = 'A time entry for work hours cannot be added in the future.';
                break;
            }
        }
        return valid;
    },

    areBreaksEmpty(model) {
        let valid = null;
        model.breaks.forEach((item, idx) => {
           if (item.start !== null && item.end === null || item.start === null && item.end !== null) {
               valid = {
                   index: idx,
                   message: 'Please fill in all break fields'
               };
           }
        });
        return valid;
    },

    areJobsEmpty(model) {
        let valid = null;
        model.jobs.forEach((item, idx) => {
            if ((item.start !== null && item.end === null) || (item.start === null && item.end !== null)
                || (item.job_id !== null && item.start === null && item.end === null)) {
                valid = {
                    index: idx,
                    message: 'Please fill in all job fields'
                };
            }
        });
        return valid;
    },

    areJobCodesSelected(model) {
        let valid = null;
        model.jobs.forEach((item, idx) => {
            if (item.start !== null && item.end !== null && item.job_id === null) {
                valid = {
                    index: idx,
                    message: 'Please select Job Code'
                };
            }
        });
        return valid;
    },

    areBreakCodesSelected(model) {
        let valid = null;
        model.breaks.forEach((item, idx) => {
            if (item.id === null && item.start !== null && item.end !== null && item.break_code_id === null) {
                valid = {
                    index: idx,
                    message: 'Please select Break Type'
                };
            }
        });
        return valid;
    },

    areBreaksInsideTimeClock(model) {
        let date = model.dates[0];
        let start = Vue.moment(date + ' ' + model.clock_in, 'YYYY-MM-DD HH:mm:ss');
        let end = Vue.moment(date + ' ' + model.clock_out, 'YYYY-MM-DD HH:mm:ss');
        if(end < start) {
            end.add(1, 'day');
        }

        let breaks = model.breaks.filter(item => { return !item.deleted && item.start !== null && item.end !== null; });
        if(breaks.length > 0){
            let minBreak = breaks.reduce((prev, curr) => { return prev.start < curr.start ? prev : curr; });
            let maxBreak = breaks.reduce((prev, curr) => { return prev.start > curr.start ? prev : curr; });
            let minBreakStart = Vue.moment(date + ' ' + minBreak.start, 'YYYY-MM-DD HH:mm:ss');
            let maxBreakEnd = Vue.moment(date + ' ' + maxBreak.end, 'YYYY-MM-DD HH:mm:ss');
            if (minBreakStart < start || maxBreakEnd > end){
                return false
            }
        }
        return true;
    },

    areJobsInsideTimeClock(model) {
        debugger;
        let date = model.dates[0];
        let start = Vue.moment(date + " " + model.clock_in, "YYYY-MM-DD HH:mm:ss");
        let end = Vue.moment(date + " " + model.clock_out, "YYYY-MM-DD HH:mm:ss");
        if(end < start) {
            end = end.add(1, 'day');
        }

        let jobs = model.jobs.filter(item => { return !item.deleted && item.start !== null && item.end !== null; });

        if(jobs.length > 0){
            let minJob = jobs.reduce((prev, curr) => { return prev.start < curr.start ? prev : curr; });
            let maxJob = jobs.reduce((prev, curr) => { return prev.start > curr.start ? prev : curr; });
            let minJobStart = Vue.moment(date+" "+ minJob.start, "YYYY-MM-DD HH:mm:ss");
            let maxJobEnd = Vue.moment(date+" "+ maxJob.end, "YYYY-MM-DD HH:mm:ss");
            if (minJobStart < start || maxJobEnd > end){
                return false
            }
        }

        return true;
    },

    areJobsInsideBreaks(model) {
        debugger;
        let breaks = model.breaks.filter((item) => { return !item.deleted && item.start !== null && item.end !== null });
        let jobs = model.jobs.filter((item) => { return !item.deleted && item.start !== null && item.end !== null });

        let sortedBreaks = breaks.sort((a, b) => { return a.start - b.start; });
        let sortedJobs = jobs.sort((a, b) => { return a.start - b.start; });
        let date = model.dates[0];

        for (let i=0; i <sortedBreaks.length; i++) {
            let breakStart = Vue.moment(date+" "+ sortedBreaks[i].start, "YYYY-MM-DD HH:mm:ss");
            let breakEnd = Vue.moment(date+" "+ sortedBreaks[i].end, "YYYY-MM-DD HH:mm:ss");

            for (let j=0; j < sortedJobs.length; j++){
                let jobStart = Vue.moment(date+" "+ sortedJobs[j].start, "YYYY-MM-DD HH:mm:ss");
                let jobEnd = Vue.moment(date+" "+ sortedJobs[j].end, "YYYY-MM-DD HH:mm:ss");

                if ((jobStart > breakStart && jobStart < breakEnd)
                    || (jobEnd > breakStart && jobEnd < breakEnd)){
                    return false
                }
            }

        }

        return true
    },

    validateBreakOverlaps(model) {

        let overlapRows = [];
        const date = model.dates[0];
        let filteredBreaks = model.breaks.filter((item) => { return !item.deleted && item.start !== null && item.end !== null });

        if(filteredBreaks.length > 0){
            const sortedBreaks = filteredBreaks.sort((a, b) => {
                const startDate = Vue.moment(date + ' ' + a.start, 'YYYY-MM-DD HH:mm:ss');
                const endDate = Vue.moment(date + ' ' + b.start, 'YYYY-MM-DD HH:mm:ss');
                return startDate - endDate;
            });

            for (let i=0; i<sortedBreaks.length; i++){
                if (i < sortedBreaks.length-1){

                    let start = sortedBreaks[i].start;
                    let end = sortedBreaks[i].end;
                    let nextStart = sortedBreaks[i+1].start;
                    let nextEnd = sortedBreaks[i+1].end;

                    if (!(start < nextEnd && nextStart > end)) {
                        let overlappingBreak = model.breaks.filter((item) => { return item.local_id === sortedBreaks[i].local_id });
                        let index = model.breaks.indexOf(overlappingBreak[0]);
                        if(index > -1){
                            overlapRows.push({
                                index: index,
                                message: "There is a time overlap in your break hours. Please adjust and try again."
                            })
                        }
                    }
                }

                if (sortedBreaks[i].start >= sortedBreaks[i].end){
                    let overlappingBreak = model.breaks.filter((item) => { return item.local_id === sortedBreaks[i].local_id });
                    let index = model.breaks.indexOf(overlappingBreak[0]);
                    if(index > -1){
                        overlapRows.push({
                            index: index,
                            message: "Start time cannot be greater than or equal to End time."
                        })
                    }
                }
            }
        }

        return overlapRows
    },

    validateJobOverlaps(model) {

        let overlapRows = [];
        const date = model.dates[0];
        let filteredJobs = model.jobs.filter((item) => { return !item.deleted && item.start !== null && item.end !== null });

        if(filteredJobs.length > 0){
            const sortedJobs = filteredJobs.sort((a, b) => {
                const startDate = Vue.moment(date + ' ' + a.start, 'YYYY-MM-DD HH:mm:ss');
                const endDate = Vue.moment(date + ' ' + b.start, 'YYYY-MM-DD HH:mm:ss');
                return startDate - endDate;
            });

            for (let i=0; i<sortedJobs.length; i++){
                if (i < sortedJobs.length-1){

                    let start = sortedJobs[i].start;
                    let end = sortedJobs[i].end;
                    let nextStart = sortedJobs[i+1].start;
                    let nextEnd = sortedJobs[i+1].end;

                    if (!(start < nextEnd && nextStart > end)) {
                        let overlappingJob = model.jobs.filter((item) => { return item.local_id === sortedJobs[i].local_id });
                        let index = model.jobs.indexOf(overlappingJob[0]);
                        if(index > -1){
                            overlapRows.push({
                                index: index,
                                message: "There is a time overlap in your job hours. Please adjust and try again."
                            })
                        }
                    }
                }

                if (sortedJobs[i].start >= sortedJobs[i].end){
                    let overlappingJob = model.jobs.filter((item) => { return item.local_id === sortedJobs[i].local_id });
                    let index = model.jobs.indexOf(overlappingJob[0]);
                    if(index > -1){
                        overlapRows.push({
                            index: index,
                            message: "Start time cannot be greater than or equal to End time."
                        });
                    }
                }
            }
        }

        return overlapRows
    },

    isValidTimeOffHours(model) {
        return !(model.hours === null || model.hours === undefined || model.hours === "");
    },

    hasTimeOffCode(model){
        return !(model.time_off_id === null || model.time_off_id === undefined || model.time_off_id === 0
            || model.time_off_id === "");
    }
}
